import * as React from "react";
import { LOBState } from "src/stores/wizard/state";
import { UitkLayoutConditionalGridSpan, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkPrimaryButton, UitkButtonSize } from "uitk-react-button";
import { useLocalization } from "@shared-ui/localization-context";

export interface SubmitButtonProps {
  lobState: LOBState;
  colSpan?: UitkLayoutConditionalGridSpan;
  className?: string;
}

export const SubmitButton: React.FunctionComponent<SubmitButtonProps> = ({ colSpan, lobState, className }) => {
  const { formatText } = useLocalization();

  return (
    <UitkLayoutGridItem colSpan={colSpan} className={className ? className : ""}>
      <div>
        <UitkPrimaryButton
          data-testid="submit-button"
          tag="button"
          type="submit"
          text={formatText(lobState.config.form.submitButton.locToken)}
          size={UitkButtonSize.LARGE}
          isFullWidth={true}
        />
      </div>
    </UitkLayoutGridItem>
  );
};
